import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';
import { FormInputEmail, FormInputUrl } from '@/_containers';

import type { PartnerFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<PartnerFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            label="Partner (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="code"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            label="Code"
            {...field}
            disabled={!isEditable}
            onChange={(e) => {
              field.onChange(e);
            }}
          />
        )}
      />

      <FormField
        control={form.control}
        name="website"
        render={({ field }) => (
          <FormInputUrl
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            label="Website"
            {...field}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormInputEmail
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            label="Email"
            {...field}
            disabled={!isEditable}
          />
        )}
      />
    </>
  );
}
